import normalizeExcludedEmailDomain from '~/components/page/Settings/LFASettings/utils/normalizeExcludedEmailDomain';
import isValidExcludedEmailDomain from '~/components/page/Settings/LFASettings/utils/isValidExcludedEmailDomain';

/**
 * Normalize and filter a list of domain strings for sending to the backend.
 * - Trim and lowercase each entry.
 * - Remove empty strings.
 * - Only include valid domains (invalid entries are filtered out).
 */
const normalizeExcludedEmailDomainsForSubmit = (
  domains: Array<string>,
): Array<string> => {
  const seen = new Set<string>();
  const result: Array<string> = [];
  for (const d of domains) {
    const normalized = normalizeExcludedEmailDomain(d);
    if (normalized === '') continue;
    if (!isValidExcludedEmailDomain(d)) continue;
    if (seen.has(normalized)) continue;
    seen.add(normalized);
    result.push(normalized);
  }
  return result;
};

export default normalizeExcludedEmailDomainsForSubmit;
